import React from "react";

const Navbar = ({ logo, back, menu }) => {
  return (
    <nav className="navbar">
      <div>{back}</div>
      {logo}
      <div>{menu}</div>
    </nav>
  );
};

export default Navbar;
